// src/index.tsx
import { jsonSchema, tool } from "ai";
import zodToJsonSchema from "zod-to-json-schema";
import { jsx } from "react/jsx-runtime";
var defineToolSpec = (spec) => spec;
function createServerTools({
  specs = [],
  exec = {},
  clientTools
}) {
  const out = {};
  specs.forEach((spec) => {
    const name = spec.name;
    const handler = exec[name];
    if (handler) {
      out[name] = tool({
        description: spec.description,
        parameters: spec.parameters,
        execute: handler
      });
    } else {
      console.warn(`No server handler found for tool ${String(name)}`);
    }
  });
  if (clientTools) {
    Object.entries(clientTools).forEach(
      ([name, clientTool]) => {
        out[name] = tool({
          description: clientTool.description,
          parameters: jsonSchema(clientTool.parameters)
        });
      }
    );
  }
  return out;
}
function createOnToolCall({ specs, exec }) {
  return ({ toolCall }) => {
    const { toolName, args } = toolCall;
    const handler = exec[toolName];
    if (!handler)
      return;
    return handler(args);
  };
}
function serializeClientTools(specs) {
  return Object.fromEntries(
    specs.map((s) => [
      s.name,
      {
        description: s.description,
        // Convert Zod schema to JSON Schema for server-side use
        parameters: zodToJsonSchema(s.parameters)
      }
    ])
  );
}
var ToolPart = ({
  part,
  Components,
  FallbackToolPart = ({ part: part2, ...props2 }) => /* @__PURE__ */ jsx("pre", { children: JSON.stringify(part2.toolInvocation, null, 2) }),
  ...props
}) => {
  const result = part.toolInvocation.state === "result" ? part.toolInvocation.result : void 0;
  const Component = Components[part.toolInvocation.toolName];
  if (Component) {
    return /* @__PURE__ */ jsx(Component, { args: part.toolInvocation.args, result, ...props });
  }
  return /* @__PURE__ */ jsx(FallbackToolPart, { part, ...props });
};
export {
  ToolPart,
  createOnToolCall,
  createServerTools,
  defineToolSpec,
  serializeClientTools
};
